<av-card class="survey" [backdrop]="false">
  <av-card-header (close)="skip()"></av-card-header>
  <av-card-body class="survey-body">
    @for (q of questions() | orderBy : 'order'; track q; let i = $index) {
    <av-card-row class="fx-column fx-gap">
      <div class="question-header fx-row fx-align-center fx-gap">
        <div>
          <div class="question-index">{{ i + 1 }}</div>
        </div>
        <span>{{ q.question }}</span>
      </div>
      <av-card-body>
        @switch (q.type) { @case (typeShortText) {
        <app-survey-text
          #questionRef
          [index]="i + 1"
          [question]="q"
          (changed)="answerChanged($event)"
        >
        </app-survey-text>
        } @case (typeLongText) {
        <app-survey-text
          #questionRef
          [index]="i + 1"
          [question]="q"
          (changed)="answerChanged($event)"
        >
        </app-survey-text>
        } @case (typeLongScore) {
        <app-survey-score
          #questionRef
          [index]="i + 1"
          [question]="q"
          (changed)="answerChanged($event)"
        >
        </app-survey-score>
        } @case (typeShortScore) {
        <app-survey-score
          #questionRef
          [index]="i + 1"
          [question]="q"
          (changed)="answerChanged($event)"
        >
        </app-survey-score>
        } @case (typeSingleChoice) {
        <app-survey-option-single
          #questionRef
          [index]="i + 1"
          [question]="q"
          (changed)="answerChanged($event)"
        >
        </app-survey-option-single>
        } @case (typeMultipleChoice) {
        <app-survey-option-multi
          #questionRef
          [index]="i + 1"
          [question]="q"
          (changed)="answerChanged($event)"
        >
        </app-survey-option-multi>
        } }
      </av-card-body>
    </av-card-row>
    }
  </av-card-body>

  <av-card-footer class="fx-column fx-gap">
    @if (!isFormValid()) {
    <av-card type="info">
      <av-card-body size="sm" type="container">{{
        "Please fill in all required fields." | translate
      }}</av-card-body>
    </av-card>
    }
    <div class="fx-row fx-gal">
      <button
        class="fx-flex-1"
        avButton
        ofType="basic"
        (click)="skip()"
        translate
        data-tid="survey/skip"
      >
        skip
      </button>
      <button
        class="fx-flex-1"
        avButton
        color="accent"
        (click)="send()"
        translate
        data-tid="survey/send"
      >
        Send feedback
      </button>
    </div>
  </av-card-footer>
</av-card>
